// Connectors API client. The pairing token is shown ONCE by create/rotate; it is
// then stored vault-encrypted, so the personalised agent stays downloadable at any
// time via connectorDownloadUrl(id, …) (no transient download token).
import { api } from './api.js';

// Management (admin or "allow create connections"; owner-scoped on the server).
export const listConnectors    = () => api.get('/api/admin/connectors').then((r) => r.connectors || []);
export const createConnector   = (name) => api.post('/api/admin/connectors', { name });
export const renameConnector   = (id, name) => api.put(`/api/admin/connectors/${id}`, { name });
export const rotateConnectorToken = (id) => api.post(`/api/admin/connectors/${id}/rotate-token`, {});
export const revokeConnector   = (id) => api.post(`/api/admin/connectors/${id}/revoke`, {});
export const unrevokeConnector = (id) => api.post(`/api/admin/connectors/${id}/unrevoke`, {});
export const deleteConnector   = (id) => api.delete(`/api/admin/connectors/${id}`);

// Persistent download URL for a connector's personalised agent (token re-baked
// from the vault server-side on each request). Available any time, not just after
// create/rotate.
export const connectorDownloadUrl = (id, os = 'windows', arch = 'amd64') =>
  `/api/admin/connectors/${id}/download?os=${encodeURIComponent(os)}&arch=${encodeURIComponent(arch)}`;

// Per-connector access grants (owner or admin). Visibility = own + granted.
export const getConnectorGrants = (id) => api.get(`/api/admin/connectors/${id}/grants`).then((r) => r.userIds || []);
export const setConnectorGrants = (id, userIds) => api.put(`/api/admin/connectors/${id}/grants`, { userIds });
// Connection-capable users (minus the caller) for the Share picker.
export const listGrantableUsers = () => api.get('/api/connectors/grantable-users').then((r) => r.users || []);

// Minimal list for the connection form's "Connect via" picker (admin or creator).
export const listConnectorsLite = () => api.get('/api/connectors').then((r) => r.connectors || []);
